module.exports = __webpack_public_path__ + "static/img/i126.1099e5b0.png";